(function () {

    JustCauseService.$inject = ['$q', 'TeamScheduleService', 'ScheduleDataServiceV2'];

    function JustCauseService($q, TeamScheduleService, ScheduleDataServiceV2) {
        var self = this;
        self.workingHoursWarningsMap = {};
        self.averageTotalHoursLastYear = {};

        self.updateUsersAverageTotalHours = function () {
            var defer = $q.defer();

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    var usersIds = [];
                    var scheduledUsersIds = ScheduleDataServiceV2.flatData && Object.keys(ScheduleDataServiceV2.flatData['users']) || [];
                    var mappedUsersIds = self.averageTotalHoursLastYear && Object.keys(self.averageTotalHoursLastYear) || [];

                    for (var i in scheduledUsersIds) {
                        if (mappedUsersIds.indexOf(scheduledUsersIds[i]) === -1) {
                            usersIds.push(scheduledUsersIds[i]);
                        }
                    }

                    var nullItemIndex = usersIds.indexOf("null");
                    if (nullItemIndex > -1) {
                        usersIds.splice(nullItemIndex, 1);
                    }

                    if (usersIds.length) {
                        var payload = {
                            user_ids: usersIds.join(","),
                            week_reference_date: moment(ScheduleDataServiceV2.startDate).format('YYYY-MM-DD'),
                            previous_weeks_count: 52
                        };

                        EmployeeClockStatsAPI.getUsersAverageTotalHours(brand.id, payload)
                            .then(function (usersAverageTotalHours) {
                                setUsersAverageTotalHoursLastYear(usersAverageTotalHours);
                                defer.resolve(usersAverageTotalHours);
                            })
                            .catch(function (err) {
                                defer.resolve([]);
                                console.error(err);
                            })
                    } else {
                        defer.resolve([]);
                    }

                });

            return defer.promise;
        };

        var setUsersAverageTotalHoursLastYear = function (usersAverageTotalHours) {
            for (var i in usersAverageTotalHours) {
                var userAverageTotalHours = usersAverageTotalHours[i];
                var userAverageTotalHoursMap = {};
                userAverageTotalHoursMap['average_total_hours'] = userAverageTotalHours['average_total_hours'];
                self.averageTotalHoursLastYear[userAverageTotalHours.user_id] = userAverageTotalHoursMap;
            }
        };

        self.calculateJustCauseWarnings = function (userWeeklyHoursMap) {
            for (var userId in self.averageTotalHoursLastYear) {
                var averageTotalHours = self.averageTotalHoursLastYear[userId].average_total_hours;
                self.workingHoursWarningsMap[userId] = self.workingHoursWarningsMap[userId] || {'justCause': {}};
                self.workingHoursWarningsMap[userId]['justCause']['value'] = (averageTotalHours - (averageTotalHours * .15)) || 0;
                self.workingHoursWarningsMap[userId]['justCause']['hasWarning'] = (userWeeklyHoursMap[userId]) < self.workingHoursWarningsMap[userId]['justCause']['value'];
            }
        };

        self.reset = function () {
            self.workingHoursWarningsMap = {};
            self.averageTotalHoursLastYear = {};
        };
    }

    app.service('justCauseService', JustCauseService);
}());